import { EME_IMG_PRE_PATH, LAW_IMG_PRE_PATH, GROUP_IMG_PRE_PATH, GOV_IMG_PRE_PATH, LINK_PRE_PATH, UrlPre } from './index';

export const headBg = UrlPre + 'PC/emergency.jpg ';
export const headBgM = UrlPre + 'M/emergency.jpg';
export const frameSrc = EME_IMG_PRE_PATH + 'pc/8c89f543a13b21bdeeaf5b71a045cf74494a603f997095c3bb2e17ecad284b68.jpg';
export const frameSrcM = EME_IMG_PRE_PATH + 'm/4deee3a0deb449efe57d0c15ec0022026562df41b63ef8cd893c09ba484c49e0.jpg';

export const challenge = [
  {
    icon: EME_IMG_PRE_PATH + 'pc/a4beb859ab3528d16414767e29530a08e41222299e580bf792de38faa9eeaf86.png',
    title: `信息难直达一线，亟需提高协\n作效率`,
    desc: '亟需推动应急预案体系建设和预案演练，提升指挥调度能力，打造横纵立体式应急指挥系统',
  },
  {
    icon: EME_IMG_PRE_PATH + 'pc/3f9c0f1cb61d99f82bc666ef2290d3f37c42c64242db3f12fad3cfe964b6c583.png',
    title: '应急事件对效率及稳定性要求\n极高',
    desc: '当遇突发事件时，需快速了解现场实况，高效指挥各部门，统筹应急力量建设和统一调度',
  },
  {
    icon: EME_IMG_PRE_PATH + 'pc/4bce2b140e45a1cdc4e9d198f89d20082c6190f3b1aa043d8cc2dfed2250b96b.png',
    title: '网络复杂，要求随时随地多端\n接入',
    desc: '在极端或弱网环境下，需保证应急调度，打造高效指挥、可视化管控等新型指挥调度应用',
  },
  {
    icon: EME_IMG_PRE_PATH + 'pc/6a6de1e384f2a1442d477d103bb658a25ce75b9b3b22c677ae08e210ed869ece.png',
    title: '旧系统设备不一，孤岛式应用',
    desc: '原有多套音视频系统孤岛式应用，信息难以直达一线，需满足应急管理高效互联互通需求',
  },
];
export const frame = [
  {
    title: '高效指挥调度',
    icon: EME_IMG_PRE_PATH + 'pc/bb424dd1a78bd0f59166f8ad191632e181704ddbaa5708da8fcee47c1756342b.png',
  },
  {
    title: '可视化应急管控',
    icon: EME_IMG_PRE_PATH + 'pc/073d4701048e6b85c9d9a1374b08910b11369975e43e85a50694949196957037.png',
  },
  {
    title: '全域场景覆盖',
    icon: EME_IMG_PRE_PATH + 'pc/6158a2a50ea0cbb87ac54a9cb710ba93ff3ef59352582ab245b3599472ffcc61.png',
  },
  {
    title: '多系统融合互通',
    icon: LAW_IMG_PRE_PATH + 'pc/9a401e6f963dbfae539d904cea119af56658ef3786911cfc2703411c4101ba84.png',
  },
];
export const advantage = [
  {
    icon: EME_IMG_PRE_PATH + 'pc/66dd353038318b25a748c878eecb7cec438921465f17479b2b6a524b2a1f3c59.png',
    title: '多层级贯通',
    desc: '多级组织、多种设备、多种系统全接入，满足多点会商，支撑实战化、可视化、立体化应急调度应用',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/ba7fb7ba0a0f40557012ce829250051134a7fa360fd790dde54e3b843ca4fa6a.png',
    title: '高安全保密',
    desc: '全自研底层技术，国密算法端到端全链路加密，架构级安全保障，通过等保三级2.0+可信云双重安全资质认证',
  },
  {
    icon: EME_IMG_PRE_PATH + 'pc/8b9a05ed8fd71130f7c2a7c9882930f2c5531bf1522d43eb47e568b6b820459c.png',
    title: '多网络适应',
    desc: '适应复杂网络环境，可快速接入多种前端设备，清晰还原现场实况，助力应急指挥调度',
  },
  {
    icon: GOV_IMG_PRE_PATH + 'pc/38dce2824d488c5ae758fce697cff2ea0c3ac160ed624d6a1be2eceae25be60b.png',
    title: '超融合应用',
    desc: '视频会议、监控、直播、录播、数据、语音融合互通，深度融合应急指挥场景，打造面向应急指挥的音视频中台，提升应急指挥能力',
  },

  {
    icon: GROUP_IMG_PRE_PATH + 'pc/b0af140cad95de7891bdab6214a51adc0bd6ffcf8da3093cde0e8f83cf9abcca.png',
    title: '强稳定可靠',
    desc: '运营级集群架构，MCU资源池，多活热备，7年不间断稳定运营，打造了超大规模的政务云视频服务平台，无单点故障',
  },
  {
    icon: GROUP_IMG_PRE_PATH + 'pc/faf1f6749cd9696565108b7f79fbfdd524c6bfce90020c55138f9eaf87719206.png',
    title: '全场景覆盖',
    desc: '覆盖应急指挥中心、大中小会议室、桌面、移动端、无人机等各类型终端，可灵活接入内外网、行业专网、互联网、4G/5G等多网络环境',
  },
];
export const scene = [
  {
    title: '应急指挥调度',
    desc: '快速搭建现场移动指挥部，满足高效灵活的指挥协调需求',
    pcUrl: EME_IMG_PRE_PATH + 'pc/eb80f177edc807519505befe43baa94811ce980864f1bbde5b1459b69f34c182.jpg',
  },
  {
    title: '值班点名',
    desc: '对值班、执勤人员进行远程视频点名，有效监管执勤人员工作状态',
    pcUrl: EME_IMG_PRE_PATH + 'pc/7acba0ee7226d5bb24bd2d5609acecb6cd8d1eff1f4e81c375351965c6e55e74.jpg',
  },
  {
    title: '危化督察',
    desc: '深入生产一线，指挥中心实时在线听取企业诉求，高效指导生产工作',
    pcUrl: EME_IMG_PRE_PATH + 'pc/bbba53c927177762cf3c02abe3fb49c3651b21813c539b05c2d3ce77e8c8dc27.jpg',
  },
  {
    title: '应急演练',
    desc: '联动部门进行应急演练，实现快速部署、实时联络，全面提升抢险救援的能力',
    pcUrl: EME_IMG_PRE_PATH + 'pc/5054ede06cacda2bbcdd2d5862720f324c2edbed3aaa951e67ebbb60e5fa2ad7.jpg',
  },
  {
    title: '学习培训',
    desc: '支持视频互动、课件分享、视频直播点播、课程报名、发布与回溯等全流程培训闭环管理',
    pcUrl: EME_IMG_PRE_PATH + 'pc/aa5e3620ddf63004ec5423a1f19538008e80b3cdb2ff81760a109f1d52ebb482.jpg',
  },
  {
    title: '日常会议',
    desc: '提供4K超高清视频、8米拾音高品质音频及丰富音视频接口，支持专业会控保障',
    pcUrl: EME_IMG_PRE_PATH + '83cd82297808dbad15c299437d8f90198052ae35fef60b3c4227b0fb6350b15a.jpg',
  },
];
export const caseList = [
  [
    {
      logo: EME_IMG_PRE_PATH + '29c211455f23cad64209f6a6aae03f92b6ce3384c780e4a36573e2a2cb1296a5.png',
      title: '应急管理部',
      desc: '应急管理部积极响应《“十四五”国家应急体系规划》要求，由小鱼易连参与建设的应急管理部云会商系统，满足多网络融合，支持大规模、超高清、移动化的多场景接入，实现纵向对各省市厅局应急管理单位的云视频覆盖，横向与国家防总、水利部、气象局等部委单位进行全打通，构建快速部署、快速响应的救援生命线，极大提高应急处突和指挥调度能力。',
      link: LINK_PRE_PATH + 'd3bc94',
    },
    {
      logo: EME_IMG_PRE_PATH + 'pc/d1801e1f07213c68ba1fc7d0f998ab84557e63ecdda0523f3f4930206c72a37e.png',
      title: '青海省应急管理厅',
      desc: '为加快构建适应青海省省情现代化应急管理信息化体系，青海省应急管理厅联合小鱼易连，共同建设青海省可视化应急指挥系统，实现了应急管理部、省级政府部门、各市区县和相关单位的全打通，建立多级多部门同平台协同的应急处置机制，保障了各方协调与救援处置的高效性，让突发事件的应急处理和指挥实现“零距离”。',
      link: LINK_PRE_PATH + 'df7b4a',
    },
    {
      logo: EME_IMG_PRE_PATH + 'pc/7bfd8dcf3b39ab5574b94bf3b9fa392fe1a00430e6a7a41ec496de697b38f800.png',
      title: '贵州省应急管理厅',
      desc: '贵州省应急管理厅为提升突发事件的预防和处理能力，应用小鱼易连云视频，建立覆盖省委、省政府应急指挥中心、10个州市应急指挥中心、88个县级指挥中心和若干企业的省视频应急调度系统，打造了“纵向到底、横向到边”的应急管理体系，建立和健全全省突发事件处理机制，实现应急管理的规范化、精细化、智能化。',
      link: LINK_PRE_PATH + '1081',
    },
    {
      logo: EME_IMG_PRE_PATH + 'pc/c025f74e19188c73670cc8d9d34235b270b50ab75c6051f3f8ef152cf3a63a24.png',
      title: '陕西省应急管理厅',
      desc: '陕西省应急管理厅密切关注信息化前沿技术，立足数字化转型的发展背景，携手小鱼易连，打造覆盖全省13个地市和108个区县级单位的陕西省应急管理厅应急移动指挥平台，“直达”一线的软硬件云视频会议终端，具备视频会议、视频会商与监控融合、移动接入等三大核心能力，形成了全省统一指挥、反应灵敏、上下联动的应急管理体系，加快推动陕西应急管理体系现代化。',
      link: LINK_PRE_PATH + '8e4b1d',
    },
    {
      logo: EME_IMG_PRE_PATH + 'pc/8ca163c838343c972fd57a988817dcc5136d307e4715f26b3e78b816868c7596.png',
      title: '成都市新都区应急管理局',
      desc: '成都市新都区应急管理局携手小鱼易连打造应急指挥调度云平台，实现区应急管理局与13个乡镇街道的互动云视频指挥调度。以小鱼易连超融合云视频为基础，新都区应急指挥调度云平台，具备公网、互联网、移动4G/5G、PSTN链路等全网络接入方式，满足手机、PC、智能硬件终端、一体化全场景云视频终端、无人机等各类终端接入，助力新都区“平战结合、反应迅速”的联动指挥体系构建，让应急体系上云。',
      link: LINK_PRE_PATH + '57075c',
    },
    {
      logo: EME_IMG_PRE_PATH + 'pc/d1d5f74d014717a8519162c262e5865912e1468993fbc3815c9f3d1623f02f3c.png',
      title: '惠州市2022年度民兵应急分队',
      desc: '为做好夏季汛期抗洪抢险准备，全面提升民兵应急分队抢险救援能力，惠州军分区组织了全市7个县区120名民兵应急分队抗洪抢险专业骨干，在博罗县某水域进行集训比武。在演练中，小鱼易连云视频表现出户外连线、无人机协同等多场景应用的超强适应力，彰显了高科技民族企业对应急场景硬核的科技赋能。',
      link: LINK_PRE_PATH + '1101',
    },
  ],
];
